function ns(num) {
    return Number(num).toLocaleString('id-ID');
}

function nsA(num) {
    num = Number(num);

    if (num >= 1_000_000_000_000) {
        const triliun = Math.floor(num / 100_000_000_000) / 10;
        return triliun.toString().replace('.', ',') + 'T';
    } else if (num >= 1_000_000_000) {
        const miliar = Math.floor(num / 100_000_000) / 10;
        return miliar.toString().replace('.', ',') + 'M';
    } else if (num >= 1_000_000) {
        const juta = Math.floor(num / 100_000) / 10;
        return juta.toString().replace('.', ',') + 'jt';
    // } else if (num >= 100_000) {
    //     const ribu = Math.floor(num / 100) / 10;
    //     return ribu.toString().replace('.', ',') + 'rb';
    } else {
        return num.toLocaleString('id-ID');
    }
}
